//Changement de variante -> Update image et ID
document.querySelectorAll(".bundle-select").forEach((select) => {
  select.addEventListener("change", function () {
    select.closest(".bundle-item").querySelector(".bundle-product-image").src = this.options[this.selectedIndex].dataset.variantImgsrc;
    //select.closest('.bundle-item').querySelector('.bundle-product-price').innerHTML = this.options[this.selectedIndex].dataset.variantPrice
    if (select.dataset.type == "main" && document.querySelector("#mainProductIdInput") != null)
      document.querySelector("#mainProductIdInput").value = this.value;
  });

    // 31/08/2026 - SYNCHRO AU CHARGEMENT (demande de Sabrina : les brosses roses, pas bleues).
    //    La vignette n'etait posee QUE sur 'change'. Au chargement la page montrait donc la
    //    photo PRINCIPALE du produit (couleur n1 = Bleu paillete) alors que la variante
    //    selectionnee etait deja "Rose dore". Le mecanisme etait bon - il ne partait jamais.
    //    On ne declenche PAS un 'change' de synthese : il rejouerait les autres ecouteurs
    //    (prix, id de variante). On pose seulement l'image, comme la ligne ci-dessus.
    var _bi = select.closest('.bundle-item');
    var _im = _bi && _bi.querySelector('.bundle-product-image');
    var _op = select.options[select.selectedIndex];
    if (_im && _op && _op.dataset.variantImgsrc) _im.src = _op.dataset.variantImgsrc;
});

function addSelectedBundleToFormInputs() {
  document.querySelector("#insertBundleInputsHere").innerHTML = "";
  const idsArray = [];
  document.querySelectorAll(".bundle-item.visible").forEach((bundle, index) => {
    var id = bundle.dataset.productId;
    if (bundle.querySelector(".bundle-select") != null) {
      id = bundle.querySelector(".bundle-select").value;
    }
    idsArray.push(id);
    const value = document.createElement("div");
    value.innerHTML = '<input id="bundleProductIdInput" type="hidden" name="items[' + index + '][id]" value="' + id + '">';
    const qty = document.createElement("div");
    if (bundle.dataset.quantity != null) {
      qty.innerHTML = `<input id="bundleProductQuantityInput" type="hidden" name="items[${index}][quantity]" value="${bundle.dataset.quantity}">`;
    } else {
      if (idsArray.filter((item) => item == id).length <= 2) {
        qty.innerHTML = '<input id="bundleProductQuantityInput" type="hidden" name="items[' + index + '][quantity]" value="1">';
      } else {
        qty.innerHTML =
          '<input id="bundleProductQuantityInput" type="hidden" name="items[' +
          index +
          '][quantity]" value="' +
          (idsArray.filter((item) => item == id).length - 1) +
          '">';
      }
    }
    document.querySelector("#insertBundleInputsHere").appendChild(value);
    document.querySelector("#insertBundleInputsHere").appendChild(qty);
  });
}

if (!customElements.get("product-bundle-form")) {
  customElements.define(
    "product-bundle-form",
    class ProductBundleForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        addSelectedBundleToFormInputs();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            initPicto();
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
